import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import { Message } from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import './styles/page-common.css'

Vue.config.productionTip = false
Vue.use(ElementUI)

window.addEventListener('unhandledrejection', event => {
  const reason = event.reason
  if (!(reason instanceof Error) || !reason.message) {
    return
  }
  if (!reason._errorShown) {
    Message.error(reason.message)
    reason._errorShown = true
  }
  event.preventDefault()
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
